module.exports = __webpack_public_path__ + "7b818aed66120cc95d5124cfbfe3adf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/taiwan-05.png
// module id = 473
// module chunks = 0